import { useEffect, useState } from 'react';
import client from './api/client';

export function isLocalHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export function useAnalyticsMenu(user, checking, is3DiscCloud) {
  const [eligibility, setEligibility] = useState(null);
  const accountKey = user
    ? `${user.data_loc || ''}:${user.id}:${user.email || ''}`
    : '';
  const local = isLocalHost(window.location.hostname);

  useEffect(() => {
    setEligibility(null);
    if (local || !is3DiscCloud || !accountKey || checking) return;
    let cancelled = false;
    client
      .get('/v1/analytics/eligibility/')
      .then(({ data }) => {
        if (!cancelled)
          setEligibility({ accountKey, allowed: data?.eligible === true });
      })
      .catch(() => {
        if (!cancelled) setEligibility({ accountKey, allowed: false });
      });
    return () => {
      cancelled = true;
    };
  }, [accountKey, checking, is3DiscCloud, local]);

  return Boolean(
    user &&
    !checking &&
    (local ||
      (is3DiscCloud && eligibility?.accountKey === accountKey && eligibility.allowed)),
  );
}
